import { CodJourney } from 'src/constants/assemblyJourneys';

import { AssemblyStatesStepperProps } from './AssemblyStatesStepper.interface';
import {
  PlayArrowIconStyled,
  StepContainer,
  StepperContainer,
  StepperText,
  StopIconStyled,
} from './AssemblyStatesStepper.styled';

export const AssemblyStatesStepper = (props: AssemblyStatesStepperProps) => {
  return (
    <StepperContainer
      activeStep={Object.values(CodJourney).findIndex(
        (key) => key === props.activeAssemblyJourney,
      )}
      orientation="vertical">
      {Object.values(CodJourney).map((key) => {
        return (
          <StepContainer key={key} onClick={() => props.onChange(key)}>
            {props.activeAssemblyJourney === key ? (
              <StopIconStyled data-testid={`${key}-stop`} />
            ) : (
              <PlayArrowIconStyled data-testid={`${key}-play`} />
            )}

            <StepperText
              fontWeight="400"
              width={'100%'}
              $isActive={props.activeAssemblyJourney === key}>
              {props.getLayoutTitle
                ? props.getLayoutTitle(key, key, true)
                : key}
            </StepperText>
          </StepContainer>
        );
      })}
    </StepperContainer>
  );
};
